// Skeleton das listas de chats da sidebar (Atendimento / Pendente / Geral /
// Finalizado). Espelha o layout de ChatsListItem/ChatAtendimentoItem.js —
// avatar 36px redondo com badge de canal, linha nome + hora, linha previa +
// badge — para a troca skeleton -> lista nao "pular". Tailwind puro, sem MUI,
// como o item que ele substitui enquanto carrega.

const LINHAS = 7;

// Larguras variadas por linha para nao parecer um bloco repetido.
const LARGURA_NOME = ['w-[55%]', 'w-[42%]', 'w-[63%]', 'w-[48%]', 'w-[58%]', 'w-[40%]', 'w-[52%]'];
const LARGURA_PREVIA = ['w-[82%]', 'w-[68%]', 'w-[90%]', 'w-[74%]', 'w-[60%]', 'w-[86%]', 'w-[70%]'];

function ItemSkeleton({ indice }) {
  const bloco = 'rounded bg-gray-200 dark:bg-neutral-800';
  return (
    <div className="px-3 py-2 border-b border-gray-100 dark:border-neutral-800">
      <div className="flex gap-2.5">
        {/* Avatar + badge de canal */}
        <div className="relative flex-shrink-0 mt-0.5">
          <div className="w-9 h-9 rounded-full bg-gray-200 dark:bg-neutral-800" />
          <div className="absolute -top-0.5 -right-0.5 w-4 h-4 rounded-full bg-white dark:bg-neutral-900 flex items-center justify-center shadow-sm">
            <div className="w-2.5 h-2.5 rounded-full bg-gray-200 dark:bg-neutral-800" />
          </div>
        </div>

        <div className="flex-1 min-w-0">
          {/* Linha 1: nome + hora */}
          <div className="flex items-center justify-between gap-2">
            <div className={`h-3 ${bloco} ${LARGURA_NOME[indice % LARGURA_NOME.length]}`} />
            <div className={`h-2.5 w-8 flex-shrink-0 ${bloco}`} />
          </div>
          {/* Linha 2: previa + badge */}
          <div className="flex items-center justify-between gap-2 mt-2">
            <div className={`h-2.5 ${bloco} ${LARGURA_PREVIA[indice % LARGURA_PREVIA.length]}`} />
            <div className={`h-4 w-10 flex-shrink-0 rounded-full ${bloco}`} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function SkeletonListaChats() {
  return (
    <div className="animate-pulse" role="status" aria-busy="true" aria-label="Carregando conversas">
      {Array.from({ length: LINHAS }, (_, i) => (
        <ItemSkeleton key={i} indice={i} />
      ))}
    </div>
  );
}
